import {
    DisplayText as DisplayTextComponent,
    DisplayTextProps,
} from '@vista-digital/occ-ui/src/lib/subcomponents/display-text/display-text'

import { CmsDisplayTextLabel } from '../../cmsTypes/cmsDisplayTextLabel'
import { CmsLink } from '../../cmsTypes/cmsLink'
import { CustomDisplayTextLabelPart } from '@vista-digital/occ-domain/dist/types/display-text-label'
import { openInNewTab } from '../../utilities/openInNewTab'
import { urlService } from '../..'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import React from 'react'

export const DisplayText: React.FunctionComponent<{ label: CmsDisplayTextLabel[] }> = props => {
    const navigate = useNavigate()

    if (!props.label || props.label.length < 1) return null

    const occProps: DisplayTextProps = {
        label: cmsToOccDisplayText(props.label, navigate),
    }
    return <DisplayTextComponent {...occProps} />
}

// Function to convert the CMS display text to OCC display text
export const cmsToOccDisplayText = (
    label: CmsDisplayTextLabel[],
    navigate?: NavigateFunction,
    internalActions?: { [key: string]: string }
) => {
    return label.map(l => {
        if (l.link) {
            return getLink(l.link, navigate)
        } else {
            if (internalActions) {
                for (let key in internalActions) {
                    if (l.text.indexOf(key) >= 0) return getInternalAction(l.text, internalActions[key])
                }
            }
            return l.text
        }
    })
}

export const linkClick = (link: CmsLink, newTab: boolean, navigate?: NavigateFunction) => {
    if (!newTab && urlService.isRouted(link.url)) {
        setTimeout(() => {
            if (navigate) navigate(link.url)
            else window.navigate(link.url)
        }, 10)
    } else {
        if (newTab) openInNewTab(link.url)
        else document.location.assign(link.url)
    }
}

export const getLink = (link: CmsLink, navigate?: NavigateFunction): CustomDisplayTextLabelPart => {
    return {
        text: link.name,
        href: link.url,
        openInNewTab: link.target && link.target == '_blank' ? true : false,
        onClick: () => {
            linkClick(link, link.target && link.target == '_blank' ? true : false, navigate)
        },
    }
}

export const getInternalAction = (text: string, internalAction: string): CustomDisplayTextLabelPart => {
    return {
        text: text,
        internalAction: internalAction,
    }
}

export const displayTextLinkGenerator = (link: CmsLink) => {}
